/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Bischof_Neumann_Schule4Inputs */

const en__field__enum_schoolname_bischof_neumann_schule4 = /** @type {(inputs: _Field__Enum_Schoolname_Bischof_Neumann_Schule4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Königstein`)
};

const de__field__enum_schoolname_bischof_neumann_schule4 = /** @type {(inputs: _Field__Enum_Schoolname_Bischof_Neumann_Schule4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bischof-Neumann-Schule`)
};

/**
* | output |
* | --- |
* | "Königstein" |
*
* @param {_Field__Enum_Schoolname_Bischof_Neumann_Schule4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_bischof_neumann_schule4 = /** @type {((inputs?: _Field__Enum_Schoolname_Bischof_Neumann_Schule4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Bischof_Neumann_Schule4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_bischof_neumann_schule4(inputs)
	return de__field__enum_schoolname_bischof_neumann_schule4(inputs)
});
export { _field__enum_schoolname_bischof_neumann_schule4 as "_field__enum_schoolName_Bischof_Neumann_Schule" }